import React from 'react'
import { Outlet } from 'react-router-dom'

function MainTeam() {
  return (
   <div>
      <Outlet/>
    </div>
  )
}

export default MainTeam